// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__t+vpa","logo_skeleton":"Logo_logo_skeleton__t2QKC"};